import { LabelVariant } from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';
import _ from 'lodash';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { getConditionalArray } from 'utils/data';
import { formatDate } from 'utils/date';

import {
  WORKSHEET_CHECKLIST_NOT_PASSED_SUFFIX,
  WORKSHEET_CHECKLIST_PASSED_SUFFIX,
  WORKSHEET_LAST_SAVED_PREFIX,
  WORKSHEET_NOT_SAVED_LABEL,
} from './WorksheetStatusBar.constants';

const TRUE_TEXT = 'true';
const FALSE_TEXT = 'false';

// While a worksheet is still loading its saved copy, "Not saved yet" would wrongly tell the auditor a
// completed audit was never saved -- show nothing until the load settles.
export const getWorksheetLastSavedLabel = ({ lastSavedAt, isLoading }) => {
  if (lastSavedAt) {
    return `${WORKSHEET_LAST_SAVED_PREFIX} ${formatDate(lastSavedAt, COMMON_DATETIME_FORMAT, {
      includeLocalOffset: true,
    })}`;
  }

  return isLoading ? null : WORKSHEET_NOT_SAVED_LABEL;
};

// A True/False calculated value reads as a pass/fail pill; any other value is shown neutrally.
const getCalculatedValueVariant = value => {
  const text = String(value ?? '').toLowerCase();

  if (text === TRUE_TEXT) {
    return LabelVariant.GREEN;
  }

  return text === FALSE_TEXT ? LabelVariant.RED : LabelVariant.GRAY;
};

/**
 * The status pills at the top of the worksheet: each calculated value and the linked checklist's
 * result, so the processor sees whether the worksheet is done without scrolling to the bottom.
 */
export const buildWorksheetStatusChips = ({ calculatedValues = [], checklistResult = null }) => [
  ...calculatedValues.map(({ calculationFieldId, name, value }) => ({
    key: calculationFieldId,
    title: `${name}: ${_.isNil(value) || value === '' ? '—' : value}`,
    variant: getCalculatedValueVariant(value),
  })),
  ...getConditionalArray(!!checklistResult, () => [
    {
      key: checklistResult.checklist.id,
      title: `${checklistResult.checklist.name} ${
        checklistResult.calculatedResult
          ? WORKSHEET_CHECKLIST_PASSED_SUFFIX
          : WORKSHEET_CHECKLIST_NOT_PASSED_SUFFIX
      }`,
      variant: checklistResult.calculatedResult ? LabelVariant.GREEN : LabelVariant.RED,
    },
  ]),
];
